import React from "react";
import { withTranslation } from "react-i18next";
import { useLeaveTypes } from "repositories/leave-repository";
import fileIcon from "assets/images/file-icon.svg";
import DataBox from "./DataBox";
function LeaveDetail({ t, staffLeaves, renderName }) {
  const { isLoading, data: apiRes } = useLeaveTypes();

  let leaves = null;
  if (
    !isLoading &&
    apiRes &&
    apiRes.data &&
    apiRes.data.leave_type
  ) {
    leaves = apiRes.data.leave_type.map((it) => {
      const staffLeave = staffLeaves.find((sl) => sl.typeId === it.id);
      let value = 0;
      if (staffLeave) value = staffLeave.leaves;

      return (
        <>
          <DataBox
            key={it.id}
            icon={fileIcon}
            label={it.name + " " + t("form.fields.leaves")}
          >
            {renderName(value)} {t("accountOwner.daysPerYear")}
          </DataBox>
        </>
      );
    });
  }

  return leaves;
}

export default withTranslation()(LeaveDetail);
